<template>
    <v-footer height="auto" class="white pa-3">
        <span class="caption">Tasklaw - Software Jurídico &copy; {{ new Date().getFullYear() }}</span>
        <v-spacer></v-spacer>
        <span class="caption mr-1">build 04122024z</span>
    </v-footer>
</template>

<script>
export default {
    name: 'footer-bar'
}
</script>
